var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group-item',[_c('div',{staticClass:"font-weight-bold text-primary"},[_vm._v(" Açıklama ")]),(_vm.dataItem.notes)?[_c('div',[_vm._v(_vm._s(_vm.dataItem.notes))])]:[_c('div',{staticClass:"text-muted"},[_vm._v(" Belirtilemdi ")])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }